import React from 'react';
import { setCurrentView } from 'core/utils';
import { ReturnLabelViewStore } from 'modules/order/stores';
import { ReturnLabelTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new ReturnLabelViewStore(rootStore, componentProps),
	'returnLabelViewStore'
)
class ReturnLabel extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ReturnLabelTemplate {...this.props} />;
	}
}

export default ReturnLabel;
